<div class="h-full grid grid-nogutter">

    <!-- Colonne de la demande d'autorisation -->
    <div class="col-12 lg:col-5 h-full">
        <div class="h-full flex flex-column justify-content-between">
            <!-- Logo en haut de page -->
            <div class="p-6 pb-0 pr-0">
                <img src="{{ appService.logoSrc }}" />
            </div>

            <!-- Conteneur de la demande -->
            <div class="flex justify-content-center mb-8">
                <div class="col-10 xl:col-8">
                    @if (loading) {
                    <div class="flex justify-content-center">
                        <p-progressSpinner styleClass="w-4rem h-4rem"></p-progressSpinner>
                    </div>
                    } @else if (refused) {
                    <app-message severity="error" icon="pi pi-exclamation-triangle" class="block"
                        title="Cette demande d'autorisation ne peut pas aboutir"
                        [messages]="['Le motif est affiché dans la notification. Revenez dans votre assistant IA pour relancer la connexion.']">
                    </app-message>
                    } @else if (authorizationRequest) {
                    <app-assistant-authorization-form [authorizationRequest]="authorizationRequest">
                    </app-assistant-authorization-form>
                    }
                </div>
            </div>

            <!-- Mentions légales -->
            <div class="flex-shrink-0">
                <app-legal-footer></app-legal-footer>
            </div>
        </div>
    </div>

    <!-- Colonne avec fond plus foncé -->
    <div class="col-7 h-full surface-100 justify-content-center align-items-center hidden lg:flex">
    </div>
</div>

<div class="h-full w-6 grid grid-nogutter absolute top-0 right-0">
    <div class="col-12 h-full justify-content-center align-items-center hidden lg:flex">
        <img src="assets/images/illustrations/login.png" />
    </div>
</div>
